import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/styles.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Provider} from 'mobx-react';
import StationStore from './store/StationStore';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

let stationStore = new StationStore();

ReactDOM.render(
  <Provider stationStore={stationStore}>
    <MuiThemeProvider >
      <App />
    </MuiThemeProvider>

  </Provider>
  , document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js